import { KioskNavigationHeader } from '../../../components/kiosk-navigation-header.component';
import useWizardNavigationHeader from './wizard-navigation-header.controller';

export interface WizardNavigationHeaderProps {
    title?: React.ReactNode;
    onBack?: () => void;
}

const WizardNavigationHeader = (props: WizardNavigationHeaderProps) => {
    const viewProps = useWizardNavigationHeader(props);

    return (
        <KioskNavigationHeader
            title={viewProps.title}
            onBack={viewProps.onBack}
            onHomeClick={viewProps.onHome}
        />
    );
};

export default WizardNavigationHeader;
